import React, { Component } from 'react';
import classnames from 'classnames';

const CompletedItem = (props) => {
    return <li className="list-group-item col-xs-3 disabled" title={props.item.name}>{props.item.name}</li>;
};

const FutureItem = (props) => (<li className="list-group-item col-xs-3 disabled">{props.item.name}</li>);

export default class Summary extends Component {
    render() {
        let completed = this.props.completed.map(item => {
            return (
                <CompletedItem
                    item={item}
                    key={item.key}
                />
            );
        });

        let futureItems = this.props.futureItems.filter(fi => {
            return this.props.ignored.indexOf(fi.key) === -1;
        }).map(function(item) {
            return (
                <FutureItem item={item}
                    key={item.key} />
            );
        });
        let classes = classnames({
            "navbar": true
        });
        return (
            <div>
            <nav className={classes}>
                <ul className="list-group special">
                    {completed}
                    <li className="list-group-item col-xs-3 active">{this.props.current.name}</li>
                    {futureItems}
                </ul>

            </nav>
            <h2>{this.props.current.title} <small>({this.props.current.subtext})</small></h2>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/summary/index.js